/**
 * A marca do resultado em atualização (E89.F2, GUS-50 RF05).
 *
 * Enquanto o caso é verificado — pelo automático da chegada ou por um botão —,
 * o quadro que está na tela é o ANTERIOR. Escondê-lo deixaria o perito sem nada
 * para ler durante o processamento; mostrá-lo sem marca deixaria que ele
 * conferisse um selo que o próximo segundo vai substituir. Fica à vista,
 * esmaecido e declarado (decisão do owner, 2026-09-12).
 *
 * O esmaecimento entra com atraso: o replay do automático volta em poucos
 * milissegundos, e a tela piscaria a cada chegada sem que nada tivesse mudado.
 * A saída da marca não tem atraso — o resultado novo aparece assim que chega.
 */
import { Loader2 } from 'lucide-react';

import { Badge } from '@/components/ui';
import { ptBR } from '@/i18n/pt-BR';

const t = ptBR.exameEletronico.processamentoAutomatico;

export function classeEmAtualizacao(ativa: boolean): string {
  return ativa
    ? 'opacity-50 transition-opacity delay-300 duration-base ease-sc'
    : 'transition-opacity duration-fast ease-sc';
}

/**
 * O selo, com a frase que diz o que ele significa.
 *
 * `anunciar` põe a frase numa região viva: só UM selo da tela deve anunciar, ou
 * o leitor de tela repetiria o mesmo aviso uma vez por seção.
 */
export function SeloEmAtualizacao({
  testId,
  anunciar = false,
}: {
  testId: string;
  anunciar?: boolean;
}): JSX.Element {
  return (
    <p
      className="mt-1 flex flex-wrap items-center gap-sc-2 text-body-sm text-fg-muted"
      data-testid={testId}
      {...(anunciar ? { role: 'status' } : {})}
    >
      <Badge variant="info" icon={<Loader2 className="h-3 w-3 animate-spin" aria-hidden />}>
        {t.emAtualizacao}
      </Badge>
      <span>{t.emAtualizacaoDetalhe}</span>
    </p>
  );
}
